<template>
  <component
    :is="preview ? 'div' : 'textarea'"
    v-bind="$attrs"
    :value="value"
    v-on="{
      ...$listeners,
      input: (e) => $emit('input', e.target.value),
    }"
    class="input-textarea"
    autocomplete="off"
    :class="{'input-textarea--preview': preview, 'input-textarea--error': error}"
  >{{value}}</component>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
      preview: {
        type: Boolean,
        default: false,
      },
      error: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .input-textarea {
    @include reset-input(true);
    display: block;
    width: 100%;
    min-height: r(24 * 6 + 16);
    padding: r(8);
    border: solid r(1) transparent;
    border-bottom-color: $color-black;
    resize: vertical;
    white-space: pre-line;
    background-color: #f7f7f7;
    transition: background-color 0.2s, border-color 0.2s;

    &:focus {
      border-bottom-color: $color-green-2025;
    }

    &--error,
    &--error:focus {
      background-color: $color-red-light;
      border-bottom-color: $color-red;
    }

    &--preview,
    &:disabled {
      border-bottom-color: transparent;
    }
    @media print {
      border-bottom-color: transparent;
    }
  }
</style>
